import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { CardWithSelector } from '../Card/CardWithSelector.js';
import { jsx } from '@emotion/react';
import '../Card/Card.js';
import '../Card/CardSection.js';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '../../utils/displayName.js';
import '../../utils/mergeRefs.js';
import './CheckboxCardBody.js';
import './CheckboxCardHeader.js';
import '../RadioCard/RadioCardBody.js';
import '../RadioCard/RadioCardHeader.js';
import '../Radio/Radio.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '@indeed/ihl-use-id';
import '../Label/Label.js';
import '../../utils/styled.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Flex/Flex.js';
import '../Box/Box.js';
import '../Text/Text.js';
import '../Checkbox/Checkbox.js';
import '../IndeedThemeProvider/hooks/useColorMode.js';
import '../IndeedThemeProvider/hooks/useColorModeAttribute.js';
import '../../hooks/useIsomorphicLayoutEffect.js';

/**
 * @see https://experience.indeed.design/components/ids/checkbox-card
 */
const CheckboxCard = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    cardProps,
    children,
    disabled,
    invalid,
    ...rest
  } = _ref;
  return jsx(CardWithSelector, _extends({
    selectorType: "checkbox",
    invalid: invalid,
    disabled: disabled
  }, cardProps, {
    checkboxProps: {
      ref,
      ...rest
    }
  }), children);
});
CheckboxCard.displayName = "CheckboxCard";

export { CheckboxCard };
